import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=e70e764c&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e70e764c')) {
      api.createRecord('e70e764c', component.options)
    } else {
      api.reload('e70e764c', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=e70e764c&", function () {
      api.rerender('e70e764c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2i84b91DXDHi0/JS/imageCarousel.vue"
export default component.exports